<template name="标准测量点页面新增测量点">
  <el-form :model="form" label-width="auto" class="add-measure-point-form" :label-position="labelPosition"  :size="size">
    <el-form-item prop="type">
      <template #label>
        <div>
          {{ Lang.Title.standardPointType }} <span class="required">*</span>
        </div>
      </template>
      <el-select
        :disabled="isView"
        v-model="form.stype"
        :placeholder="Lang.tips.plzSelect+ ' ' +Lang.Title.standardPointType"
        style="width: 100%"
      >
        <el-option
          v-for="item in typeOptions"
          :key="item.i18nValue"
          :label="item.i18nValue"
          :value="item.dictKey"
          :disabled="item.disabled"
        />
      </el-select>
    </el-form-item>
    <el-form-item  prop="format">
      <template #label>
        <div>
          {{ Lang.Title.standardPointFormat }} <span class="required">*</span>
        </div>
      </template>
      <el-select
        :disabled="isView"
        v-model="form.datatype"
        :placeholder="Lang.tips.plzSelect+ ' ' +Lang.Title.standardPointFormat"
        style="width: 100%"
      >
        <el-option
          v-for="item in formatOptions"
          :key="item.i18nValue"
          :label="item.i18nValue"
          :value="item.dictKey"
          :disabled="item.disabled"
        />
      </el-select>
      <div class="notice">{{ Lang.Text.standardPointCantModify }}</div>
    </el-form-item>


    <!-- 表格 -->
    <el-form-item label="" prop="name">
      <el-table :data="nameTableData" border class="add-measure-point-table">
        <!-- 语言 -->
        <el-table-column comment="语言" prop="language" :label="Lang.Title.standardPointLangVer" width="180" >
          <template  #default="{row, $index }">
            <span v-if="row.language!='EN'">{{ row.language }}</span>
            <span v-else>{{ row.language }} <span class="required">*</span></span>
          </template>
        </el-table-column>
        
        <el-table-column comment="测量点" prop="name" >
          <template #header>
            <div>
              {{ Lang.Title.standardPointPoint }} <span class="required">*</span>
            </div>
          </template>
          <template #default="{row, $index }">
            <el-input
              maxlength="100"
              :disabled="isView"
              v-model="nameTableData[$index][row.key]"
              :placeholder="isView ? '': Lang.tips.plzInput+ ' ' +Lang.Title.standardPointPoint"
            />
          </template>
        </el-table-column>

        <el-table-column comment="单位" prop="unit" :label="Lang.Title.standardPointUnit">
          <template #default="{ $index }">
            <el-mention
              maxlength="20"
              v-model="nameTableData[$index].unit"
              :disabled="nameTableData[$index].unitType == 2 || isView"
              :options="unitOptions"
              style="width: 320px"
              :placeholder="(nameTableData[$index].unitType == 3 && !isView) ? (Lang.tips.plzInput+ ' ' +Lang.Title.standardPointUnit) : ''"
            />
          </template>
        </el-table-column>
      </el-table>
    </el-form-item>

    <!-- des -->
    <el-form-item :label="Lang.Title.standardPointNote" prop="des">
      <el-input
        :disabled="isView"
        v-model="form.des"
        type="textarea"
        maxlength="500"
        :show-word-limit="true"
        :placeholder="isView ? '': Lang.tips.plzInput+ ' ' +Lang.Title.standardPointNote"
      />
    </el-form-item>

    <!-- enum table -->
    <el-form-item v-if="form.datatype == 'Enumerate'">
      <EnumTable
        :enumTableData="enumTableData"
        :languageOptions="UN_SORT_LANGUAGE_OPTIONS"
        :isView="isView"
        @update:enumTableData="(newData) => (enumTableData = newData)"
      />
    </el-form-item>
    <el-form-item v-if="!isView">
      <div style="display: flex; justify-content: center; margin-top: 40px; width: 100%;">
        <comp-button size="large" type="default" style="width: 120px;" @click="onCancel">{{ Lang.btn.cancel }}</comp-button>
        <comp-button size="large" type="primary" style="width: 120px;" @click="onSubmit">{{ Lang.btn.confirm }}</comp-button>
      </div>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { reactive, ref, onMounted, computed, readonly } from 'vue';
import { UN_SORT_LANGUAGE_OPTIONS } from '@/lang/language';
import { getDictionary } from '@/api/system/dict';
import {
  getDetail,
} from '@/api/gateway/measurementPoint';
import EnumTable from '@/views/gatewayManage/comps/enumTable.vue';
import { ElMessage } from 'element-plus';
import { Lang, langKeyNameMap } from '@/lang/lang';


const props = defineProps({
  itemId: {
    type: String,
    default: '',
  },
  operation: {
    type: String,
    default: 'add',
  },
  labelPosition: {
    type: String,
    default: 'top',
  },
  isView: {
    type: Boolean,
    default: false,
  },
  auth: {
    type: Object,
    default: () => ({
      add: true,
      edit: true,
      delete: true,
    }),
  },
});

const emit = defineEmits(['submit', 'cancel']);

const form = reactive({
  stype: '',
  datatype: '',
  des: '',
  unit: null,
});

const nameTableData = reactive([]);

const isView = computed(() => {
  return props.operation === 'view';
});

const typeOptions = ref([ ]);
const formatOptions = ref([ ]);
const unitOptions = ref([
  {
    label: 'No Unit',
    value: 'No Unit',
  },
  {
    label: 'Custom Unit',
    value: 'Custom Unit',
  },
])

const enumTableData = reactive([
  // {
  //   Parameter: '',
  //   'en-US': '',
  //   'th-TH': '',
  //   'zh-CN': '',
  // },
]);

function getDetailData() {
  if (['edit', 'view'].includes(props.operation)) {
    getDetail({ id: props.itemId }).then(res => {
      const data = res.data.data;
      if (res.data.code === 200) {
        form.stype = data.stype;
        form.datatype = data.datatype;
        form.des = data.des;
        form.id = data.id;
        const i18ns = data.i18ns;
        nameTableData.forEach((item) => {
          const nameItem = i18ns.find(ele => ele.i18nField == 'name' && ele.i18nLanguage == item.key) || {}
          const unitItem = i18ns.find(ele => ele.i18nField == 'unit' && ele.i18nLanguage == item.key) || {}
          item['zh-CN'] = data.name;
          item['en-US'] = data.enName;
          item[item.key] = nameItem.i18nValue;
          item.unit = unitItem.i18nValue;
        });
        const itemEnumList = [];
        data.itemEnumList.map(item => {
          const obj = {
            parameter: item.parameter,
          }
          UN_SORT_LANGUAGE_OPTIONS.forEach(lang => {
            obj[lang.key] = item[langKeyNameMap[lang.key]]
          });
          itemEnumList.push(obj)
        });
        if (itemEnumList.length > 0) {
          enumTableData.length = 0; // 清空数组
          enumTableData.push(...itemEnumList); // 添加新数据
          console.log(enumTableData); // 确认更新
        }
      }
    });
  }
}

function getDeptParam() {
  const item = nameTableData.find(item => item.key === 'zh-CN');
  const enItem = nameTableData.find(item => item.key === 'en-US');
  const otherKey = nameTableData.find(key => !['zh-CN', 'en-US'].includes(key.key)).key;
  const localItem = nameTableData.find(item => item.key === otherKey);
  const i18ns = [];
  nameTableData.map(item => {
    i18ns.push({
      i18nField: 'name',
      i18nLanguage: item.key,
      i18nValue: item[item.key]
    })
    i18ns.push({
      i18nField: 'unit',
      i18nLanguage: item.key,
      i18nValue: item.unit
    })
  })
  const itemEnumList = [];
  enumTableData.forEach(item => {
    const row = {};
    UN_SORT_LANGUAGE_OPTIONS.forEach(ele => {
      row[langKeyNameMap[ele.key]] = item[ele.key]   // enName: param
    })
    row.parameter = item.parameter;
    itemEnumList.push(row)
  })

  return {
    id: props.operation == 'add' ? '' : form.id,
    name: item['zh-CN'].trim(),
    enName: enItem['en-US'].trim(),
    localName: localItem[otherKey].trim(),
    unit: item.unit,
    enUnit: enItem.unit,
    localUnit: localItem.unit,
    stype: form.stype,
    datatype: form.datatype,
    des: form.des,
    i18ns,
    itemEnumList,
  };
}

function initNameTable() {
  UN_SORT_LANGUAGE_OPTIONS.forEach((item) => {
    nameTableData.push({
      language: item.name, // EN CN ...
      key: item.key,
      [item.key]: '', // Dynamic key assignment Name
      unit: '',
      unitType: 3,
    })
  })
  console.log(nameTableData);
}

function onCancel() {
  emit('cancel');
}

function onSubmit() {
  console.log('submit!');
  console.log(nameTableData, enumTableData);
  let validateName = true;
  let validateUnit = true;
  let validateParameter = true;
  let validateEnum = true;
  if (!form.stype) {
    return ElMessage.error(Lang.tips.plzSelect +'  '+ Lang.Title.standardPointType)
  }
  if (!form.datatype) {
    return ElMessage.error(Lang.tips.plzSelect +'  '+ Lang.Title.standardPointFormat)
  }
  nameTableData.forEach(item => {
    if (item.key == 'en-US') {
      if (!item[item.key]) {
        validateName = false;
      }
      // if (!item.unit) {
      //   validateUnit = false;
      // }
    }
  })
  if (!validateName) {
    return ElMessage.error(Lang.tips.plzInput +' EN '+ Lang.Title.standardPointPoint)
  }
  // if (!validateUnit) {
  //   return ElMessage.error(Lang.tips.plzInput +' EN '+ Lang.Title.standardPointUnit)
  // }
  if (enumTableData.length) {
    enumTableData.forEach(item => {
      if (!item['en-US']) {
        validateEnum = false;
      }
      if (!item.parameter) {
        validateParameter = false;
      }
    })
    if (!validateParameter) {
      return ElMessage.error(Lang.tips.plzInput + ' ' + Lang.Title.standardPointParam)
    }
    if (!validateEnum) {
      return ElMessage.error(Lang.tips.plzInput + Lang.label.name + ' _EN')
    }
  }
  const params = {
    ...form,
    ...getDeptParam(),
  };
  console.log(params);
  emit('submit', params);
}

onMounted(() => {
  getDictionary({ code: 'typesOfTelemetering' }).then(res => {
    const data = res.data.data;
    if (res.data.code === 200) {
      typeOptions.value = data;
    }
  });
  getDictionary({ code: 'itemFormat' }).then(res => {
    const data = res.data.data;
    if (res.data.code === 200) {
      formatOptions.value = data;
    }
  });
  if (props.operation == 'add') {
    getDetailData();
  }
  initNameTable();
  getDetailData();
});


</script>
